<template>
	<main class="practice-sheet-new-edit">
    <div _bg="white" _p="x-20px t-15px b-20px" _border="rounded-[11px]">
      <div class="practiceList">
        <div class="aigx" @click="ReturnSuperior" _text="17px">
          <i class="el-icon-arrow-left superior" style="font-size: 15px; font-weight: 1000;"></i>
          <span>&nbsp;&nbsp;返回</span>
        </div>
      </div>
      <div _m="t-25px b-20px" _flex="~ justify-between">
        <div _text="18px [#181818]" class="font-bold">教师姓名：{{ infox.account.realname }}</div>
        <div _text="16px [#8C8C8C]">学科：
          <template
            v-for="(subjects, index) in subjects?.filter(
              (item, index, self) =>
                index ==
                self?.findIndex(
                  elem => elem?.id == item?.id && elem?.name == item?.name && elem?.slug == item?.slug
                )
            )"
          >
            <svg
              :key="index"
              class="icon"
              aria-hidden="true"
              style="width: 18px; height: 18px; outline: none; box-shadow: none;"
            >
              <use v-if="subjects.name === '音乐'" xlink:href="#icon-music2" style="color: #0681c5;"></use>
              <use v-else xlink:href="#icon-arts" style="color: #00ad6b;"></use></svg
            >&nbsp;&nbsp;{{ subjects.name }}&nbsp;&nbsp;
          </template>
        </div>
      </div>
      <div _flex="~ justify-between" _text="[#8C8C8C]">
        <div _flex="~">
          <div>账号：{{ infox.account.login_name }}</div>
          <div _m="l-20px">班级：{{ banji }}</div>
        </div>
        <div _flex="~">
          <div>学校：{{ infox.school.name }}</div>
          <span _m="x-10px">|</span>
          <div>辖区：{{ diqu }}</div>
          <span _m="x-10px">|</span>
          <div>微信授权：{{ wichartsis }}</div>
        </div>
      </div>
    </div>
    <div _m="t-15px" _bg="white" _p="x-20px y-10px" _border="rounded-[11px]">
      <div _m="y-23px" _text="19px [#181818]" class="font-bold">课件信息</div>
      <el-table :data="tableData" tooltip-effect="dark" :header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }" style="width:100%;min-height: 580px;">
        <el-table-column align="left" label="激活码" prop="license_id"></el-table-column>
        <el-table-column align="left" label="出版社" prop="extra.publisher.name"></el-table-column>
        <el-table-column align="left" label="导入课件名称" prop="import_title"></el-table-column>
        <el-table-column align="left" label="导入时间" prop="created_at"></el-table-column>
        <el-table-column align="left" label="失效时间" prop="expired_at"></el-table-column>
        <el-table-column align="left" label="课件转移教师姓名" prop="move_to.from_user.realname"></el-table-column>
        <el-table-column align="left" label="课件转移教师账号" prop="move_to.from_user.login_name"></el-table-column>
        <el-table-column align="left" label="课件转移教师手机号码" prop="move_to.from_user.mobile"></el-table-column>
        <el-table-column align="left" label="课件转移时间" prop="move_to.created_at"></el-table-column>
      </el-table>
      <div class="pagination-page">
        <span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / size) }}页</span>
        <el-pagination
          class="pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="size"
          :total="totalItems"
          :current-page.sync="page"
          :page-sizes="[10, 20, 50, 100]"
          layout="prev,pager,next,jumper,sizes"
          style="margin-top: 21px; margin-left: 10px;"
        >
        </el-pagination>
      </div>
    </div>
	</main>
</template>
<script>
export default {
	data() {
		return {
			infox: {
				account: [null],
				school: { district_division: [null] }
			}, // 曲谱信息
			diqu: '', //地区
			wichartsis: '', //微信授权
			xuek: '', //学科
			banji: '', //班级
      tableData: [],
      page: 1,
      size: 20,
      totalItems: 0,
      id: '',
      subjects: []
		}
	},
	mounted() {
    this.id = this.$route.params.id
		this.CheckCheck(this.id)
    this.refreshDataList()
	},
	methods: {
		async CheckCheck(scoreid) {
			let res = null
			res = await this.$api.teacher.TeacherInfo(scoreid)
			this.infox = res
			this.diqu =
				res.school.district_division.l1_name +
				res.school.district_division.l2_name +
				(res.school.district_division.l3_name ? '' + res.school.district_division.l3_name : '')
			this.wichartsis = res.account.openid === null ? '未授权' : '已授权'
			for (let index = 0; index < res.subjects.length; index++) {
				this.xuek += res.subjects[index].name + '  '
			}
      this.subjects = res.subjects
      let arr = []
			for (let index = 0; index < res.class_grades.length; index++) {
        arr[index] = res.class_grades[index].class_name
			}
      this.banji = arr.join('、')
		},
		ReturnSuperior() {
			this.$router.go(-1)
		},
    async refreshDataList() {
      const { meta, data } = await this.$api.user.httpGet(`teacher/info/${this.id}`)
      this.totalItems = meta.total
      this.tableData = data
    },
    handleSizeChange(val) {
      this.page = 1 
      this.size = val
      this.refreshDataList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.refreshDataList()
    }
	}
}
</script>
<style lang="scss" scoped>
.practice-sheet-new-edit {
	min-height: 810px;
}
.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
</style>
